/**
 * 数据管理-数据源下载
 */
import React from 'react';
import './index.less';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import {
    Form, Input, Select, Button, message as Message, Table, message, Modal, DatePicker, Radio
} from "antd";
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { GetDataTaskList, GetDownLoadUrl, createDataTask, GetListEnume } from "../../../../services/project/DownLoadService";
import { readTenantCode, removeCustomerDownload, writeCustomerDownload } from '../../../../utils/storage';

let _this;
const { Option } = Select;


const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 },
};

class DataDownloadComponent extends React.Component {

    constructor(props) {
        super(props);
        _this = this;
        _this.state = {
            dataLists: [], // 列表集合
            columns: [
                {
                    title: '任务名称',
                    width: '',
                    render: (text, record, index) => {
                        return (
                            <div className={'con_div'}>
                                <div className={'title'}>{record.taskName}</div>
                            </div>
                        )
                    }
                },
                {
                    title: '开始时间',
                    width: '',
                    render: (text, record, index) => {
                        if (record.startTime) {
                            return (
                                <div className={'con_div'}>
                                    <div className={'sub-title'}>
                                        {record.startTime == 'null' ? '' : record.startTime ? record.startTime.replace('T', ' ') : ''}
                                    </div>
                                </div>
                            )
                        }
                    }
                },
                {
                    title: '完成时间',
                    width: '',
                    render: (text, record, index) => {
                        if (record.finishTime) {
                            return (
                                <div className={'con_div'}>
                                    <div className={'sub-title'}>{record.finishTime == 'null' ? '' : record.finishTime ? record.finishTime.replace('T', ' ') : ''}</div>
                                </div>
                            )
                        }
                    }
                },
                {
                    title: '创建类型',
                    width: '',
                    render: (text, record, index) => {
                        return (
                            <div className={'con_div current_state'}>
                                {record.createUser}
                            </div>
                        )
                    }
                },
                {
                    title: '状态',
                    width: '',
                    render: (text, record, index) => {
                        return (
                            <div className={'con_div current_state'}>
                                {/* 0-生成中 1-已完成 */}
                                <Button type={record.createState == 0 ? 'link' : 'text'}>
                                    {
                                        record.createState == 0 ? '生成中' : '已完成'
                                    }
                                </Button>
                            </div>
                        )
                    }
                },
                {
                    title: '进度',
                    width: '',
                    render: (text, record, index) => {
                        return (
                            <div className={'con_div'}>
                                <div className={'title'}>{record.process}</div>
                            </div>
                        )
                    }
                },
                {
                    title: '操作',
                    width: '',
                    render: (text, record) =>
                        <div
                            onClick={eve => {
                                eve.stopPropagation();
                            }}
                            className={'partPop'}
                        >
                            <Button type="link" onClick={() => this.downLoadData(record)} disabled={record.createState == '0'}>
                                下载数据
                            </Button>
                        </div>
                },
            ],// 表格 行 配置
            page: 1,//当前页码数
            pagination: { // 分页组件元素对象信息
                onChange: (pageNo) => {
                    this.getPageData(pageNo);
                },
                current: 1,
                pageSize: 10,
                total: 100,
                showSizeChanger: false,
            },
            isCreateVisible: false, // 创建数据下载任务模态框
            projectList: [], // 所有项目
            projectCodes: [], // 项目code
            currentDate: null, // 检索日期
            disableDownLoad: false,
            caseStartDate: null, // 起始时间
            caseEndDate: null, // 截至时间
        }
    }

    formRef = React.createRef();

    componentDidMount = () => {
        writeCustomerDownload()
        // 列表
        this.getPageData(); 
        // 获取项目枚举
        this.getProjectEnume(); 
    }

    componentWillUnmount = () => {
        removeCustomerDownload()
    }

    // 获取项目枚举
    getProjectEnume = () => {
        GetListEnume().then(res => {
            this.setState({
                projectList: res || []
            })
        })
    }

    /**
     * 下载数据
     */
    downLoadData = async (record) => {
        let params = {
            id: record.id
        }
        GetDownLoadUrl(params).then(res => {
            if (res && res.code == 0) {
                window.open(res.data);
            }
        })
    }

    /**
     * 获取列表数据 
     */
    getPageData = async (curPage) => {
        let { page, currentDate } = this.state;

        const params = {
            tenantCode: readTenantCode(),
            page: curPage ? curPage : page,
            pageSize: this.state.pagination.pageSize,
            startDate: currentDate || '',
            endDate: currentDate || ''
        }

        const res = await GetDataTaskList(params);
        if (res && res.code == 0) {
            _this.setState({
                dataLists: [...res.data.rows],
                page: res.data.page,
                pageSize: res.data.pageSize,
                pagination: {
                    ...this.state.pagination,
                    current: res.data.page,
                    pageSize: res.data.pageSize,
                    total: res.data.total,
                }
            })
        }
    }

    // 取消
    handleCancel = async () => {
        this.setState({
            isCreateVisible: false
        })
    }

    // form过滤空格
    getValueFromEvent = (event) => {
        return event.target.value.replace(/\s+/g, "")
    }

    // 创建下载任务
    createTasks = () => {
        if (this.formRef.current) {
            this.formRef.current.resetFields()
        }
        
        this.setState({
            isCreateVisible: true
        })
    }

    // 选择日期
    onDateChange = (date, dateString) => {
        this.setState({
            currentDate: dateString
        }, () => {
            this.getPageData()
        })
    };

    // 创建/提交
    onSubmit = async (values) => {
        const form = this.formRef.current;
        const formValues = form.getFieldsValue(
            ['projectCodes', 'caseStartDate', 'caseEndDate']);
        
        let params_projectCodes = formValues.projectCodes ?? [];
        let { projectList } = this.state;
        if (!formValues.projectCodes || formValues.projectCodes.length == 0) {
            projectList && projectList.length > 0 && projectList.map(item => {
                params_projectCodes.push(item.code)
            })
        }

        if (!formValues.caseStartDate || formValues.caseStartDate == '') {
            message.error('病例完成起始时间！')
            return
        }
        if (!formValues.caseEndDate || formValues.caseEndDate == '') {
            message.error('病例完成截至时间！')
            return
        }

        let params = {
            projectCodes: params_projectCodes,
            tenantCode: readTenantCode()
        }
        
        if (formValues.caseStartDate) {
            params['startDate'] = moment(formValues.caseStartDate).format('YYYY-MM-DD');
        }
        if (formValues.caseEndDate) {
            params['endDate'] = moment(formValues.caseEndDate).format('YYYY-MM-DD');
        }
        
        const res = await createDataTask(params);
        if (res && res.code == 0) {
            message.success('创建成功！');

            _this.setState({
                isCreateVisible: false
            }, () => {
                this.getPageData()
            })
        }
    }

    render() {
        let { columns, dataLists, pagination, isCreateVisible, currentDate, projectList } = this.state;

        dataLists.length > 0 && dataLists.map((item, index) => {
            item['key'] = index + 1
        })

        return (
            <div className='data_sourceData'>
                <div className={'download_wrap'}>
                    <div className={'title_wrap'}>
                        <div>源数据下载</div>
                        <div className={'search_wrap'}>
                            <DatePicker
                                onChange={this.onDateChange}
                                locale={locale}
                                value={currentDate ? moment(currentDate, 'YYYY-MM-DD') : null}
                            />
                            &nbsp;&nbsp;&nbsp;&nbsp;

                            <Button type="primary" size={'middle'} onClick={() => this.createTasks()}>
                                创建数据下载任务
                            </Button>
                        </div>
                    </div>

                    <Table
                        locale={{ emptyText: "暂无数据" }}
                        columns={columns}
                        dataSource={dataLists}
                        pagination={dataLists.length !== 0 && pagination}
                        rowKey={'id'}
                    />
                </div>

                {/* 创建数据下载任务 */}
                <Modal
                    title="创建数据下载任务"
                    visible={isCreateVisible}
                    onOk={this.onSubmit}
                    okText='确认创建'
                    cancelText='关闭'
                    onCancel={this.handleCancel}
                    width='50%'
                >
                    <Form
                        {...layout}
                        name="nest-messages"
                        onFinish={this.onSubmit}
                        requiredMark={true}
                        ref={this.formRef}
                        autoComplete="off"
                    >
                        <Form.Item
                            label="请选择项目"
                            name='projectCodes'
                            rules={[{ required: false, message: '如果不选择项目，默认下载本租户下所有项目数据!' }]}
                            style={{marginBottom: 10}}
                        >
                            <Select
                                onChange={this.handleChange}
                                placeholder='请选择项目'
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                allowClear
                                mode="multiple"
                                style={{maxHeight: '200px', overflowY: 'auto'}}
                                className={'modal_project_select'}
                            >
                                {projectList.length > 0 && projectList.map(project => (
                                    <Option key={project.code} value={project.code}>{project.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="病例完成起始时间"
                            name="caseStartDate"
                            rules={[{ required: true, message: '请输入病例完成起始时间!' }]}
                        >
                            <DatePicker
                                locale={locale}
                                style={{width: '100%'}}
                            />
                        </Form.Item>
                        <Form.Item
                            label="病例完成截至时间"
                            name="caseEndDate"
                            rules={[{ required: true, message: '请输入病例完成截至时间!' }]}
                        >
                            <DatePicker
                                locale={locale}
                                style={{width: '100%'}}
                            />
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        );
    }
}
export default withRouter(DataDownloadComponent);